export enum AcaoLogGeral {
  Inclusao,
  Alteracao,
  Exclusao,
}
